<template>
  <div>
    <div v-if="loading" class="text-center">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          style="margin-top: 150px;"
          color="primary"
          size="48"
        ></v-progress-circular>
        <div
          class="text-center info-primary-text fw-700 PSLKanda4Pro"
          style="padding-top: 48px; font-size: 22px;"
        >
          {{ $t("checking") }} ...
        </div>
      </div>
    </div>
    <div v-else class="wrapper">
      <div class="header-info">
        <v-layout wrap>
          <v-flex xs5 class="white--text PSLKanda4Pro">
            <span style="font-size: 32px; line-height: 32px;"
              >TG
              {{
                status == "Change"
                  ? flightnoFormatted(data.user_flight_check)
                  : flightnoFormatted(data.flight_no_check)
              }}</span
            >
          </v-flex>
          <v-flex xs7 class="text-right">
            <span
              class="text-center white--text py-1 px-3"
              style="font-size: 14px; line-height: 14px; border: 1px solid #fff; border-radius: 8px;"
            >
              <span class="pr-2 PSLKanda4Pro">{{ $t("flight_time") }}</span>
              <span class="PSLKanda2Pro"
                >{{ flightTime || "-" }} {{ $t("hours") }}</span
              >
            </span>
          </v-flex>
        </v-layout>
      </div>
      <div class="content">
        <perfect-scrollbar>
          <div class="d-flex justify-space-between">
            <div>
              <span
                v-if="status === 'Change'"
                class="info-secondary-bg white--text px-2 py-1 PSLKanda4Pro"
                style="font-size: 11px; border-radius: 16px"
                >*TG{{
                  status == "Change"
                    ? flightnoFormatted(data.user_flight_check)
                    : flightnoFormatted(data.flight_no_check)
                }}
                ({{ dateFormattedWithoutYear(data.user_flight_date_check) }})
                {{ $t("change_to") }} TG{{ data.flight_no_check }} ({{
                  dateFormattedWithoutYear(data.std_lt)
                }})
              </span>
            </div>
            <div>
              <v-img
                width="64px"
                max-width="64px"
                src="@/assets/logo-small.png"
              ></v-img>
            </div>
          </div>
          <div class="pt-4">
            <v-layout wrap>
              <v-flex xs5 class="text-center info-primary-text">
                <div class="label-fullname PSLKanda2Pro">
                  {{ data.departure_stn_name || "-" }}
                </div>
                <div class="label-shortname PSLKanda2Pro">
                  {{ data.departure_stn || "-" }}
                </div>
                <div class="label-utc PSLKanda4Pro pt-2">
                  UTC {{ data.departure_utc || "-" }}
                </div>
              </v-flex>
              <v-flex xs2 class="d-flex justify-center align-center py-1">
                <v-img
                  width="36px"
                  height="36px"
                  max-width="36px"
                  src="@/assets/arrow.png"
                ></v-img>
              </v-flex>
              <v-flex xs5 class="text-center info-primary-text">
                <div class="label-fullname PSLKanda2Pro">
                  {{ data.arrival_stn_name || "-" }}
                </div>
                <div class="label-shortname PSLKanda2Pro">
                  {{ data.arrival_stn || "-" }}
                </div>
                <div class="label-utc PSLKanda4Pro pt-2">
                  UTC {{ data.arrival_utc || "-" }}
                </div>
              </v-flex>
            </v-layout>
          </div>
          <div class="pt-3" v-if="status === 'OK' || status === 'Change'">
            <v-layout wrap>
              <v-flex
                xs12
                class="table-header white--text py-2 text-center PSLKanda4Pro"
                :class="
                  status === 'OK' ? 'info-primary-bg' : 'info-secondary-bg '
                "
              >
                <v-layout wrap>
                  <v-flex xs6>
                    {{ dateFormatted(data.std_lt) }}
                  </v-flex>
                  <v-flex xs6>
                    {{ dateFormatted(data.sta_lt) }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="table-body py-3 text-center PSLKanda4Pro">
                <v-layout wrap>
                  <v-flex
                    xs6
                    :class="
                      status === 'OK'
                        ? 'info-primary-text'
                        : 'info-secondary-text'
                    "
                    :style="
                      status === 'OK'
                        ? 'border-right: 1px solid #542285;'
                        : 'border-right: 1px solid #cc0099;'
                    "
                  >
                    <div class="text-uppercase label-utc">
                      {{ $t("scheduled") }}
                    </div>
                    <div class="table-body-time fw-500">
                      {{ timeFormatted(data.std_lt) }}
                    </div>
                    <div class="text-uppercase label-utc pt-3">
                      {{ $t("actual") }}
                    </div>
                    <div class="table-body-time fw-500">
                      {{ timeFormatted(data.atd_lt) }}
                    </div>
                  </v-flex>
                  <v-flex
                    xs6
                    :class="
                      status === 'OK'
                        ? 'info-primary-text'
                        : 'info-secondary-text'
                    "
                  >
                    <div class="text-uppercase label-utc">
                      {{ $t("scheduled") }}
                    </div>
                    <div class="table-body-time fw-500">
                      {{ timeFormatted(data.sta_lt) }}
                    </div>
                    <div class="text-uppercase label-utc pt-3">
                      {{ $t("estimated") }}
                    </div>
                    <div class="table-body-time fw-500">
                      {{ timeFormatted(data.ata_lt) }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="text-center pt-3 PSLKanda4Pro">
                <v-layout wrap>
                  <v-flex xs6 class="info-primary-text">
                    <div class="label-utc">
                      {{ $t("gate") }}
                    </div>
                    <div class="table-body-time fw-700">
                      {{ data.gate || "-" }}
                    </div>
                    <div class="label-utc pt-3">
                      {{ $t("terminal") }} {{ data.departure_terminal || "-" }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="info-primary-text">
                    <div class="label-utc">
                      {{ $t("baggage_carousel") }}
                    </div>
                    <div class="table-body-time fw-700">
                      {{ data.belt || "-" }}
                    </div>
                    <div class="label-utc pt-3">
                      {{ $t("terminal") }} {{ data.arrival_terminal || "-" }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <div
            v-else-if="status === 'Cancel'"
            class="info-box-cancelled text-center info-primary-text mt-3 pt-4 pb-5"
          >
            <div class="text-uppercase label-utc PSLKanda3Pro">
              {{ $t("status") }}
            </div>
            <div class="fw-700 pt-4 PSLKanda4Pro" style="font-size: 30px;">
              {{ $t("flight_cancelled") }}
            </div>
            <div style="font-size: 20px;" class="pt-4 pb-5 PSLKanda2Pro">
              {{ $t("flight_cancelled_text_1") }}<br />
              {{ $t("flight_cancelled_text_2") }}<br />
              {{ $t("flight_cancelled_text_3") }}
            </div>
            <div>
              <v-btn
                color="#362062"
                rounded
                class="mr-2 text-capitalize white--text PSLKanda2Pro"
                :disabled="data.next_flight_no == ''"
              >
                <v-icon class="pr-1">mdi-arrow-left</v-icon>
                {{ $t("prior_flight") }}
              </v-btn>
              <v-btn
                color="#362062"
                rounded
                class="ml-2 text-capitalize white--text PSLKanda2Pro"
                :disabled="data.prev_flight_no == ''"
              >
                {{ $t("next_flight") }}
                <v-icon class="pl-1">mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
      <div
        class="footer-info d-flex align-center"
        :style="{ backgroundImage: bgFooter }"
      >
        <v-layout wrap>
          <v-flex xs6></v-flex>
          <v-flex
            xs6
            class="d-flex justify-center align-center"
            v-if="status === 'OK'"
          >
            <div class="pr-3">
              <v-img
                width="28px"
                max-width="28px"
                src="@/assets/icon-airplane.png"
              ></v-img>
            </div>
            <div class="white--text footer-text">
              <div class="pb-1">Airbus 350-900</div>
              <div>{{ data.aircraft_regis || "-" }}</div>
            </div>
          </v-flex>
          <v-flex xs6 v-else class="text-center">
            <div
              class="info-primary-text PSLKanda2Pro"
              style="font-size: 16px;"
            >
              We are here for you.
            </div>
            <div class="pt-1">
              <span
                class="footer-button PSLKanda4Pro"
                @click="onRedirectContactus"
                >{{ $t("contact_us") }}</span
              >
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      data: [],
      status: null,
      loading: false,
    };
  },
  async mounted() {
    await this.getData();
  },
  computed: {
    bgFooter() {
      return this.status === "OK"
        ? `url(${require("@/assets/footer-info-normal.jpg")})`
        : `url(${require("@/assets/footer-info-changed.jpg")})`;
    },
    query() {
      return this.$store.state.query;
    },
    flightTime() {
      if (this.data.flight_time) {
        let time = this.data.flight_time;
        return time.includes(":")
          ? time
          : time.substring(0, 2) + ":" + time.substring(2, time.length);
      } else {
        return "";
      }
    },
  },
  methods: {
    async getData() {
      const vm = this;
      vm.loading = true;
      await axios
        .get(`${vm.serverUrl}flight/checkStatusFlight`, {
          params: {
            userid: vm.query.userid,
            pageid: vm.query.pageid,
            status: vm.query.status,
            flightno: vm.query.flightno,
            flightdate: vm.query.flightdate,
          },
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then(async (response) => {
          if (response && response.data.responsecode == 200) {
            vm.status = vm.query.status;
            vm.loading = false;
            vm.data = response.data.data;
          }
        });
    },
    dateFormatted(date) {
      if (this.query.lang == "th") {
        moment.locale("th");
      } else {
        moment.locale("en");
      }
      return date ? moment(date).format("DD MMMM YYYY") : "";
    },
    dateFormattedWithoutYear(date) {
      if (this.query.lang == "th") {
        moment.locale("th");
      } else {
        moment.locale("en");
      }
      return date ? moment(date).format("DD MMMM") : "";
    },
    timeFormatted(time) {
      return time ? moment(time).format("HH:mm") : "";
    },
    flightnoFormatted(val) {
      if (val) {
        let text = val.toLowerCase();
        return text.includes("tg") ? text.replace("tg", "") : text;
      } else {
        return "";
      }
    },
    async onRedirectContactus() {
      const vm = this;
      const message = vm.query.lang == "en" ? "contact us" : "ติดต่อเรา";
      await vm.$store.dispatch("sendMessage", message);
      if (vm.query.apptype == "line") {
        vm.$liff.closeWindow();
      } else {
        vm.$store.dispatch("messengerClose");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 501px) {
  .footer-info {
    left: 50% !important;
    transform: translateX(-50%);
    max-width: 500px;
  }
}
@media only screen and (min-width: 351px) {
  .wrapper {
    width: 100%;
    height: 100vh;
    max-width: 500px;
    margin: 0 auto;
    position: relative;
    background-image: url(../assets/bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top left;
  }
  .header-info {
    background-image: url(../assets/bg-header.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top 0% left 30%;
    height: 95px;
    width: 100%;
    max-width: 500px;
    padding: 0 20px 16px;
    display: flex;
    align-items: center;
    position: fixed;
    z-index: 1;
  }
  .content {
    padding: 93px 20px 110px;
    position: relative;
    background-image: url(/img/bg.74b2fd06.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top left;
  }
  .label-fullname {
    font-size: 20px;
    line-height: 20px;
    overflow-wrap: normal;
    height: 48px;
  }
  .label-shortname {
    font-size: 60px;
    line-height: 60px;
  }
  .label-utc {
    font-size: 15px;
  }
  .table-header {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    font-size: 16px;
  }
  .table-body {
    background: #fff;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
  .table-body-time {
    font-size: 32px;
    line-height: 32px;
    padding-top: 8px;
  }
  .footer-info {
    background-size: cover;
    background-position: top 0% right 35%;
    width: 100%;
    height: 85px;
    position: fixed;
    bottom: 0;
    left: 0;
  }
  .footer-text {
    font-size: 13px;
    line-height: 13px;
  }
  .footer-button {
    border: 1px solid #542285;
    border-radius: 12px;
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    padding: 4px 8px;
    cursor: pointer;
  }
  .info-box-cancelled {
    background: #fff;
    border-radius: 12px;
  }
}
.fw-500 {
  font-weight: 500;
}
.fw-700 {
  font-weight: 700;
}
.info-primary-text {
  color: #362062 !important;
}
.info-primary-bg {
  background-color: #542285 !important;
}
.info-secondary-text {
  color: #c3208f !important;
}
.info-secondary-bg {
  background-color: #cc0099 !important;
}
.text-uppercase {
  text-transform: uppercase;
}
</style>
